import styled, { css } from 'styled-components/macro'

import { mq } from 'styles/mq'
import { theme } from 'styles/theme'
import GoldenBg from 'assets/golden-bg.webp'
import { Overlay } from 'styles/misc'

export const Description = styled.p`
  margin: 0;
  font-size: clamp(1.5rem, 2.4vw, 2rem);
  line-height: 1.6;
  transition: 0.4s opacity;

  ${mq.medium} {
    width: 50%;
    margin-left: auto;
    padding: 0 1em 2.2em;
    text-align: left;
    line-height: 1.5;

    a:not(:hover) & {
      transition: 0.2s opacity;
      opacity: 0;
    }
  }
`

export const Container = styled.article<{
  imageHover?: string
  $isInView?: boolean
}>`
  position: relative;
  aspect-ratio: 8 / 6;
  margin: 0 -5rem;
  padding: 20% 25%;
  display: flex;
  text-align: center;
  z-index: 0;

  ${mq.smallOnly} {
    width: 124%;
    margin: -28% -25% 0;

    &:nth-child(2n) {
      align-self: flex-end;
    }

    &:first-child {
      margin-top: -5%;
    }

    &:last-child {
      margin-bottom: -20%;
    }

    ${props =>
      props.$isInView &&
      css`
        a::after {
          opacity: 1 !important;
        }
      `}
  }

  ${mq.extraSmall} {
    width: 150%;
  }

  ${mq.medium} {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 87rem;
    margin: -25% -15%;
    padding: min(15.5%, 15.5rem) min(20%, 20rem);

    &:nth-child(2n) {
      margin-left: auto;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &:first-child {
      z-index: 0;

      &::before,
      &::after {
        content: '';
        display: block;
        position: absolute;
        pointer-events: none;
        background: url(${GoldenBg}) 0 0 / cover no-repeat;
      }

      &::before {
        width: 187.5rem;
        height: 93.1rem;
        bottom: 50%;
        right: 100%;
        margin: -5% -21.4%;
        clip-path: path(
          'M240.074 8.16464C172.026 -3.36035 88.0274 -2.45935 0.392563 26.1232L-0.0725555 24.6971C87.8226 -3.9703 172.069 -4.8743 240.324 6.6857C308.55 18.2408 360.883 42.2656 384.907 63.5488C408.86 84.7725 427.609 110.461 444.603 137.572C453.053 151.053 461.075 164.894 469.084 178.716L469.217 178.945C477.274 192.847 485.321 206.727 493.795 220.221C532.838 282.388 589.312 340.473 655.434 366.817C639.174 340.247 633.434 306.463 638.69 275.923C644.063 244.698 660.955 216.768 689.977 203.458C733.871 183.333 788.595 204.648 817.944 242.742C834.515 264.248 844.895 292.593 838.066 319.058C833.031 338.575 819.677 353.663 802.636 364.255C785.598 374.844 764.837 380.965 744.879 382.548C715.06 384.913 686.314 380.064 659.16 369.871C693.28 421.582 754.513 448.701 814.236 466.672C898.239 491.951 1011.84 520.52 1161.6 520.52C1185.61 520.52 1213.04 518.221 1242.48 515.386C1248.55 514.802 1254.7 514.195 1260.93 513.581C1284.9 511.217 1309.93 508.748 1335.3 507.061C1399.22 502.81 1465.39 503.515 1522.19 523.422C1596.53 549.477 1649.95 584.571 1657.2 653.552C1658.29 663.978 1657.41 676.12 1655.77 689.251C1654.84 696.705 1653.65 704.521 1652.44 712.539C1651.52 718.623 1650.58 724.824 1649.72 731.073C1645.72 760.125 1643.39 790.47 1652.07 816.745C1660.31 841.666 1679.87 866.937 1703.92 886.947C1727.98 906.958 1756.45 921.634 1782.42 925.458C1821.38 931.194 1844.72 928.938 1860.44 927.42C1865.8 926.902 1870.27 926.47 1874.17 926.47V927.97C1870.4 927.97 1866.02 928.394 1860.74 928.905C1845.04 930.422 1821.37 932.709 1782.2 926.942C1755.88 923.066 1727.16 908.228 1702.96 888.101C1678.77 867.974 1659 842.484 1650.65 817.216C1641.84 790.581 1644.23 759.926 1648.23 730.868C1649.1 724.568 1650.04 718.356 1650.96 712.273C1652.17 704.284 1653.35 696.517 1654.28 689.065C1655.92 675.958 1656.78 663.957 1655.7 653.709C1648.55 585.669 1595.95 550.863 1521.69 524.838C1465.19 505.036 1399.28 504.31 1335.4 508.557C1310.06 510.242 1285.05 512.709 1261.09 515.072C1254.86 515.687 1248.7 516.294 1242.62 516.879C1213.18 519.714 1185.69 522.02 1161.6 522.02C1011.64 522.02 897.881 493.41 813.804 468.108C753.371 449.924 690.978 422.278 656.779 368.962C589.411 342.81 532 283.874 492.525 221.019C484.034 207.498 475.974 193.596 467.92 179.697L467.792 179.478C459.778 165.649 451.768 151.827 443.332 138.368C426.371 111.309 407.71 85.7578 383.913 64.6716C360.177 43.6447 308.15 19.6945 240.074 8.16464ZM657.776 367.735C685.31 378.356 714.491 383.454 744.761 381.053C764.513 379.486 785.037 373.426 801.844 362.981C818.648 352.537 831.699 337.735 836.614 318.683C843.285 292.827 833.165 264.953 816.756 243.658C787.705 205.952 733.689 185.067 690.603 204.822C662.145 217.872 645.482 245.302 640.168 276.177C634.856 307.041 640.908 341.249 657.776 367.735Z'
        );
        z-index: -2;
      }

      &::after {
        width: 171.3rem;
        height: 126.6rem;
        top: 50%;
        left: 100%;
        margin: 0 -21.4%;
        clip-path: path(
          'M279.746 85.0464C208.528 15.3839 99.9175 4.01042 -0.0107422 1.24992L0.0306793 -0.249512C99.9225 2.50998 209.112 13.8565 280.794 83.9741C344.623 146.408 363.38 241.894 363.1 330.943C362.989 366.291 360.398 401.64 357.812 436.937C357.14 446.098 356.469 455.255 355.842 464.408C352.796 508.843 350.778 553.191 354.727 597.444C358.182 636.113 366.516 675.14 386.74 708.148C408.913 744.351 444.016 771.052 481.525 791.179C523.881 813.908 569.565 829.06 615.538 843.793C618.413 844.715 621.29 845.635 624.168 846.555C667.268 860.338 710.454 874.149 751.117 893.875C794.526 914.929 836.141 946.767 865.266 985.314C879.172 1003.72 890.237 1023.66 897.286 1044.7C1024.65 1009.89 1162.72 1018.67 1291.17 1052.08C1439.26 1090.61 1577.17 1160.08 1713.01 1230.31L1712.33 1231.65C1576.47 1161.4 1438.7 1092.01 1290.79 1053.54C1162.54 1020.17 1024.78 1011.43 897.757 1046.13C905.118 1068.73 907.833 1092.58 904.453 1117.11C897.568 1167.07 865.491 1211.45 823.913 1239.84C797.896 1257.61 766.054 1270.09 734.85 1264.57C719.216 1261.81 704.304 1253.4 693.608 1241.72C682.91 1230.04 676.393 1215.05 677.652 1199.14C679.325 1178.02 693.434 1160.14 708.333 1145.44C745.296 1108.97 791.382 1082.78 839.656 1063.8C858.098 1056.55 876.847 1050.34 895.837 1045.1C888.847 1024.27 877.877 1004.49 864.069 986.219C835.109 947.889 793.693 916.192 750.463 895.225C709.899 875.547 666.809 861.767 623.685 847.976C620.817 847.059 617.948 846.141 615.08 845.222C569.115 830.491 523.309 815.303 480.815 792.501C443.184 772.308 407.827 745.449 385.46 708.932C365.064 675.64 356.698 636.348 353.233 597.577L353.98 597.51L353.233 597.577C349.272 553.2 351.299 508.753 354.345 464.305C354.974 455.136 355.646 445.969 356.318 436.801C358.904 401.511 361.489 366.228 361.6 330.938C361.88 242.026 343.137 147.052 279.746 85.0464ZM896.309 1046.52C877.343 1051.76 858.619 1057.96 840.204 1065.2C792.058 1084.12 746.164 1110.23 709.387 1146.5C694.526 1161.17 680.775 1178.72 679.148 1199.26C677.927 1214.67 684.235 1229.27 694.714 1240.71C705.196 1252.15 719.814 1260.39 735.11 1263.09C765.765 1268.51 797.204 1256.27 823.067 1238.6C864.369 1210.4 896.151 1166.37 902.967 1116.91C906.315 1092.6 903.624 1068.96 896.309 1046.52Z'
        );
      }
    }
  }

  ${mq.large} {
    width: 100%;
    margin: -15rem 0;
    padding: 12% 14%;
  }
`

export const Link = styled.a<{ $image: string; $imageHover?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: inherit;
  cursor: pointer;
  z-index: 1;

  &::before,
  &::after {
    content: '';
    ${Overlay}
    z-index: -1;
    transition: 0.6s opacity;
    pointer-events: none;
    background: url('${props => props.$image}') center center/95% auto no-repeat;
  }

  &::after {
    opacity: 0.01;
    transition: 0.6s opacity;
    background-image: url('${props => props.$imageHover}');
  }

  ${mq.smallOnly} {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 0 15%;
  }

  ${mq.medium} {
    &::before {
      background-image: url('${props => props.$image}');
    }

    ${props =>
      props.$imageHover &&
      css`
        &:hover::after {
          opacity: 1;
        }
      `}
  }
`

export const Title = styled.h2`
  font: 500 clamp(3.2rem, 6.5vw, 6.4rem) ${theme.fonts.headings};
  margin: 0 0 1rem;
  transition: 0.6s color;
  background: url(${GoldenBg}) center top / 600px auto repeat;
  -webkit-background-clip: text;
  background-clip: text;

  ${Container}:nth-child(2) & {
    margin-bottom: -1.7rem;
  }

  ${Link}:hover & {
    color: transparent;
  }
`
